import React from "react";
import { Modal, Button } from "antd";

export const LogoutModal = ({ visible, onClose, onLogout }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      closeIcon={null}
      centered
      title={
        <h3 className="text-xl font-semibold relative -top-4 text-center ">
          Are you sure you want to logout your account?
        </h3>
      }
    >
      <div className="flex flex-col sm:flex-row justify-between pt-4 gap-3">
        <Button
          onClick={onClose}
          className="px-6 py-2 border rounded-2xl w-full sm:w-1/2 btnSecondary text-gray-700 flex items-center justify-center gap-2"
        >
          Cancel
        </Button>
        <Button
          onClick={onLogout}
          className="px-6 py-2 bg-[#202835] w-full sm:w-1/2 rounded-2xl text-white flex items-center justify-center gap-2"
        >
          Logout
        </Button>
      </div>
    </Modal>
  );
};
